module.exports = __webpack_public_path__ + "static/media/_MIC2367.image.8b0719d8.png";